import { createRoute } from '@tanstack/react-router';
import type { Zone } from '@hana/shell';
import { CertsScreen } from './certs/Certs';
import { CoursesScreen } from './courses/Courses';
import { ExamsScreen } from './exams/Exams';
import { HomeScreen } from './home/Home';
import { LibraryScreen } from './library/Library';
import { ManageScreen } from './manage/Manage';
import { PathScreen } from './path/Path';
import { currentSearch, eduNav } from './nav';

// Vùng HANA Edu (/edu): đào tạo, khoá học, chứng chỉ (luồng B, docs/streams/B.md). Board Mint-Training.
// TODO(A): gắn vào apps/hub/src/zones.tsx (issue 243) + manifest PWA.

export const zone: Zone = {
  key: 'edu',
  name: 'HANA Edu',
  // Menu chung của Hub (sidebar 248 / rail 64), theo người xem — xem nav.ts
  get top() {
    return eduNav(currentSearch()).top;
  },
  get nav() {
    return eduNav(currentSearch()).nav;
  },
  routes: (parent) => [createRoute({ getParentRoute: () => parent, path: '/', component: HomeScreen }),
    createRoute({ getParentRoute: () => parent, path: 'courses', component: CoursesScreen }),
    createRoute({ getParentRoute: () => parent, path: 'path', component: PathScreen }),
    createRoute({ getParentRoute: () => parent, path: 'exams', component: ExamsScreen }),
    createRoute({ getParentRoute: () => parent, path: 'certs', component: CertsScreen }),
    createRoute({ getParentRoute: () => parent, path: 'library', component: LibraryScreen }),
    createRoute({ getParentRoute: () => parent, path: 'manage', component: ManageScreen }),
    createRoute({ getParentRoute: () => parent, path: 'manage/done', component: ManageScreen }),
    createRoute({ getParentRoute: () => parent, path: 'manage/score', component: ManageScreen }),
  ],
};
